import { json, checkStatus, CustomerAPI } from '@driftt/dapper'

export const api = {
  fetchMarketoMappings() {
    return CustomerAPI.get('/marketo/mappings/attributes')
      .then(json)
  },

  patchMarketoMappings(mappings) {
    return CustomerAPI.patch('/marketo/mappings/attributes',  mappings )
      .then(checkStatus)
      .then(json)
  },

  fetchMarketoFields() {
    return CustomerAPI.get('/marketo/lead/fields')
      .then(json)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/marketo/api.js